import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function extractAuthor(digest) {
  var sessionValidators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _digest$logs$filter = digest.logs.filter(function (e) {
    return e.isConsensus;
  }),
      _digest$logs$filter2 = _slicedToArray(_digest$logs$filter, 1),
      citem = _digest$logs$filter2[0];

  var _digest$logs$filter3 = digest.logs.filter(function (e) {
    return e.isPreRuntime;
  }),
      _digest$logs$filter4 = _slicedToArray(_digest$logs$filter3, 1),
      pitem = _digest$logs$filter4[0];

  var _digest$logs$filter5 = digest.logs.filter(function (e) {
    return e.isSeal;
  }),
      _digest$logs$filter6 = _slicedToArray(_digest$logs$filter5, 1),
      sitem = _digest$logs$filter6[0];

  var accountId;

  try {
    // This is critical to be first for BABE (before Consensus)
    // If not first, we end up dropping the author at session-end
    if (pitem) {
      var _pitem$asPreRuntime = _slicedToArray(pitem.asPreRuntime, 2),
          engine = _pitem$asPreRuntime[0],
          data = _pitem$asPreRuntime[1];

      accountId = engine.extractAuthor(data, sessionValidators);
    }

    if (!accountId && citem) {
      var _citem$asConsensus = _slicedToArray(citem.asConsensus, 2),
          _engine = _citem$asConsensus[0],
          _data = _citem$asConsensus[1];

      accountId = _engine.extractAuthor(_data, sessionValidators);
    } // SEAL, still used in e.g. Kulupu for pow


    if (!accountId && sitem) {
      var _sitem$asSeal = _slicedToArray(sitem.asSeal, 2),
          _engine2 = _sitem$asSeal[0],
          _data2 = _sitem$asSeal[1];

      accountId = _engine2.extractAuthor(_data2, sessionValidators);
    }
  } catch (_unused) {// ignore
  }

  return accountId;
}